/**
 * Copies text to the user's clipboard using the modern Clipboard API
 * @param text The text to copy to clipboard
 * @returns Promise that resolves to true if successful, false if failed
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
};
